<template>
  <div class="anz-posts">
    <template v-if="profile.isHideSubscribedUsers && !isShowingCurrentUser">
      <div
        class="anz-align-center anz-ml-auto anz-mr-auto anz-mt-xl anz-pt-xl anz-mt-xxl-sm anz-pt-xxl-sm anz-mb-xxl"
        :style="{ width: '270px' }"
      >
        <div
          class="anz-color-gray-100 anz-mb-s anz-mt-l anz-mt-xxl-sm anz-pt-xxl-sm"
        >
          <a-icon width="4.3571em" height="5.2857em" name="lock" />
        </div>
        <span class="anz-color-black-30">
          {{ $translate('profile.labels.privateSubscribersNotice') }}
          <strong class="anz-strong anz-color-default"
            >{{ $translate('profile.labels.private') }}.</strong
          ></span
        >
      </div>
    </template>
    <template v-else>
      <Suspense>
        <template #default>
          <subscribers-list />
        </template>
        <template #fallback>
          <a-loader :title="$translate('profile.other.loadingSubscribers')" />
        </template>
      </Suspense>
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import ALoader from '@/components/ALoader.vue'
import SubscribersList from '@/components/Profile/SubscribersList.vue'
import { useProfileShow } from '@/composables/user/user'
import AIcon from '@/components/AIcon.vue'

export default defineComponent({
  name: 'SubscriberPostList',
  components: { AIcon, SubscribersList, ALoader },
  setup() {
    return {
      ...useProfileShow(),
    }
  },
})
</script>
